import NavBar from "../components/Nav";
import Form from "../components/Form";
const Register = () => {
	return (
		<>
			<NavBar />
			<Form />
		</>
	);
};

export default Register;
